/**
 * @generated SignedSource<<b8ac77242fe9aa482a26ed70485341f0>>
 * @relayHash 7dac482d1cfd5a28854a0820682bd12f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9594d19512d0b12a68a3c38761925e88d1279ffaa9fa2d6bbc5b1a40894d7798

import type { ConcreteRequest } from 'relay-runtime';
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type CommentsPanelQuery$variables = {
  pageId: string;
};
export type CommentsPanelQuery$data = {
  readonly comments: {
    readonly nodes: ReadonlyArray<{
      readonly author: {
        readonly accountId?: string | null;
        readonly displayName: string | null;
        readonly permissionType: SitePermissionType | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
      };
      readonly body: {
        readonly value: string;
      };
      readonly contentStatus: string;
      readonly createdAt: {
        readonly value: string;
      };
      readonly createdAtNonLocalized: string;
      readonly id: string;
      readonly links: {
        readonly editui: string | null;
        readonly webui: string | null;
      };
      readonly location: {
        readonly commentResolveProperties?: {
          readonly resolved: boolean;
          readonly resolvedFriendlyDate: string | null;
          readonly resolvedTime: AGG$Long | null;
          readonly resolvedUser: string | null;
        } | null;
        readonly inlineMarkerRef?: string | null;
        readonly inlineResolveProperties?: {
          readonly isDangling: boolean;
          readonly resolved: boolean;
          readonly resolvedFriendlyDate: string | null;
          readonly resolvedTime: AGG$Long | null;
          readonly resolvedUser: string | null;
        } | null;
        readonly inlineText?: string | null;
        readonly type: string;
      };
      readonly parentId: string | null;
      readonly permissions: {
        readonly isEditable: boolean;
        readonly isRemovable: boolean;
        readonly isResolvable: boolean;
      };
      readonly replies: ReadonlyArray<{
        readonly author: {
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly permissionType: SitePermissionType | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
        };
        readonly body: {
          readonly value: string;
        };
        readonly contentStatus: string;
        readonly createdAt: {
          readonly value: string;
        };
        readonly createdAtNonLocalized: string;
        readonly id: string;
        readonly links: {
          readonly editui: string | null;
          readonly webui: string | null;
        };
        readonly location: {
          readonly commentResolveProperties?: {
            readonly resolved: boolean;
            readonly resolvedFriendlyDate: string | null;
            readonly resolvedTime: AGG$Long | null;
            readonly resolvedUser: string | null;
          } | null;
          readonly inlineMarkerRef?: string | null;
          readonly inlineResolveProperties?: {
            readonly isDangling: boolean;
            readonly resolved: boolean;
            readonly resolvedFriendlyDate: string | null;
            readonly resolvedTime: AGG$Long | null;
            readonly resolvedUser: string | null;
          } | null;
          readonly inlineText?: string | null;
          readonly type: string;
        };
        readonly parentId: string | null;
        readonly permissions: {
          readonly isEditable: boolean;
          readonly isRemovable: boolean;
          readonly isResolvable: boolean;
        };
        readonly version: {
          readonly by: {
            readonly displayName: string | null;
          } | null;
          readonly number: number | null;
          readonly when: string | null;
        };
      } | null>;
      readonly version: {
        readonly by: {
          readonly displayName: string | null;
        } | null;
        readonly number: number | null;
        readonly when: string | null;
      };
    } | null> | null;
    readonly totalCount: number | null;
  } | null;
};
export type CommentsPanelQuery = {
  response: CommentsPanelQuery$data;
  variables: CommentsPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "depth",
    "value": "ROOT"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  },
  {
    "kind": "Variable",
    "name": "pageId",
    "variableName": "pageId"
  },
  {
    "kind": "Literal",
    "name": "type",
    "value": "UNRESOLVED"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v4 = {
  "args": [
    {
      "kind": "Literal",
      "name": "representation",
      "value": "ATLAS_DOC_FORMAT"
    }
  ],
  "concreteType": "DocumentBody",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
},
v5 = {
  "kind": "ScalarField",
  "name": "contentStatus"
},
v6 = {
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdAt",
  "plural": false,
  "selections": (v3/*: any*/)
},
v7 = {
  "kind": "ScalarField",
  "name": "createdAtNonLocalized"
},
v8 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    },
    {
      "kind": "ScalarField",
      "name": "editui"
    }
  ]
},
v9 = {
  "kind": "ScalarField",
  "name": "type"
},
v10 = {
  "kind": "ScalarField",
  "name": "resolved"
},
v11 = {
  "kind": "ScalarField",
  "name": "resolvedFriendlyDate"
},
v12 = {
  "kind": "ScalarField",
  "name": "resolvedTime"
},
v13 = {
  "kind": "ScalarField",
  "name": "resolvedUser"
},
v14 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "inlineMarkerRef"
    },
    {
      "kind": "ScalarField",
      "name": "inlineText"
    },
    {
      "concreteType": "InlineCommentResolveProperties",
      "kind": "LinkedField",
      "name": "inlineResolveProperties",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isDangling"
        },
        (v11/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/)
      ]
    }
  ],
  "type": "InlineComment"
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "InlineCommentResolveProperties",
      "kind": "LinkedField",
      "name": "commentResolveProperties",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/)
      ]
    }
  ],
  "type": "FooterComment"
},
v16 = {
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/)
  ]
},
v17 = {
  "kind": "ScalarField",
  "name": "parentId"
},
v18 = {
  "concreteType": "CommentPermissions",
  "kind": "LinkedField",
  "name": "permissions",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    },
    {
      "kind": "ScalarField",
      "name": "isRemovable"
    },
    {
      "kind": "ScalarField",
      "name": "isResolvable"
    }
  ]
},
v19 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v20 = {
  "kind": "ScalarField",
  "name": "when"
},
v21 = {
  "kind": "ScalarField",
  "name": "number"
},
v22 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "name": "by",
      "plural": false,
      "selections": [
        (v19/*: any*/)
      ]
    },
    (v20/*: any*/),
    (v21/*: any*/)
  ]
},
v23 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v24 = {
  "kind": "ScalarField",
  "name": "permissionType"
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v26 = {
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    (v23/*: any*/),
    (v24/*: any*/),
    (v25/*: any*/)
  ]
},
v27 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v28 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v29 = {
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v28/*: any*/),
    (v9/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/)
  ]
},
v30 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "name": "by",
      "plural": false,
      "selections": [
        (v28/*: any*/),
        (v19/*: any*/)
      ]
    },
    (v20/*: any*/),
    (v21/*: any*/)
  ]
},
v31 = {
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v28/*: any*/),
    (v19/*: any*/),
    (v23/*: any*/),
    (v24/*: any*/),
    (v25/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CommentsPanelQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
          {
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v22/*: any*/),
              (v26/*: any*/),
              {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "replies",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v22/*: any*/),
                  (v26/*: any*/)
                ]
              }
            ]
          },
          (v27/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommentsPanelQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
          {
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v29/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "replies",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v29/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/)
                ]
              }
            ]
          },
          (v27/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "7dac482d1cfd5a28854a0820682bd12f",
    "id": "9594d19512d0b12a68a3c38761925e88d1279ffaa9fa2d6bbc5b1a40894d7798",
    "metadata": {},
    "name": "CommentsPanelQuery",
    "operationKind": "query",
    "text": "query CommentsPanelQuery($pageId:ID!){comments(pageId:$pageId,type:UNRESOLVED,depth:ROOT,first:50){nodes{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}},totalCount}}"
  }
};
})();

(node as any).hash = "2ba184201b06cec56898efcdf0235520";

export default node;
